import React, { useState } from 'react';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';

//Modelos
import SearchViniedoModel from '../../models/SearchViniedos';

//Componentes
import SearchViniedos from './SearchViniedos';

function SearchViniedosContainer() {
    const {
        token,
        masters,
        tablePage,
        setTablePage,
        SearchParameters,
        dispatchSearchParameters,
    } = useGlobalContext();
    const FormMethods = useForm();

    //Cuando se hace la búsqueda
    async function onSearch(data) {
        const ViniedosForSearch = new SearchViniedoModel(data);

        dispatchSearchParameters({
            type: 'VINIEDOS',
            payload: {
                token,
                ...ViniedosForSearch,
                pagina: tablePage,
                cantidad: 10,
            },
        });

        setTablePage(1);
    }

    return (
        <SearchViniedos
            functions={{
                ...FormMethods,
                onSearch,
            }}
            states={{
                masters,
                SearchParameters,
            }}
        />
    );
}

export default SearchViniedosContainer;
